import { useStore, useStoreUI } from '@assets/model/Store';
import { observer } from 'mobx-react';
import { Flex } from '../UI/Flex/Flex';

import { getDatabase, onValue, ref } from 'firebase/database';
import { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { ScrollPanel } from '../Panel/ScrollPanel/ScrollPanel';
import * as style from './ModalPickPromptDemo.module.less';

interface ModalPickPromptDemoProps {
    onSelectFile: (fileName: string) => void;
}

export const ModalPickPromptDemo = observer(
    (props: ModalPickPromptDemoProps) => {
        const [files, setFilesToShow] = useState([]);
        const company_id = useStore().selectedReportId;

        useEffect(() => {
            if (!company_id) return;

            const varsPath = `flowtasks/vars/${company_id}`;
            const varsRef = ref(getDatabase(), varsPath);
            const unsubVars = onValue(varsRef, data => {
                if (data.val()) {
                    const keys = Object.keys(data.val()).sort();
                    setFilesToShow(keys);
                } else {
                    setFilesToShow([]);
                }
            });

            return () => unsubVars();
        }, [company_id]);

        const filesEl = [];
        for (var fileIndex in files) {
            const fileName = files[fileIndex];
            filesEl.push(
                <div
                    className={style.fileEntry}
                    key={fileIndex}
                    onClick={() => {
                        props.onSelectFile(fileName);
                    }}
                >
                    <Flex direction="row">
                        <div
                            style={{ alignSelf: 'center', marginRight: '15px' }}
                        ></div>
                        <Flex direction="column" wrap="wrap">
                            <div>{fileName.replace('v_', '')}</div>
                        </Flex>
                    </Flex>
                </div>
            );
        }
        filesEl.push(
            <div key="padding" style={{ height: '10px', width: '100%' }}></div>
        );
        return (
            <>
                <Flex fillCell={true} direction="column" alignItems="center">
                    <ScrollPanel>
                        <Flex
                            direction="row"
                            style={{
                                width: '100%',
                                gap: '12px'
                            }}
                            wrap="wrap"
                        >
                            {filesEl}
                        </Flex>
                    </ScrollPanel>
                    <div className={style.seperator}></div>
                    <Flex
                        direction="row"
                        style={{ width: '100%', height: '40px' }}
                    >
                        <Button
                            onClick={() => {
                                const ui = useStoreUI();
                                ui.modal = null;
                            }}
                            className={style.cancelButton}
                        >
                            Cancel
                        </Button>
                        <div style={{ flexGrow: 1 }}></div>
                    </Flex>
                </Flex>
            </>
        );
    }
);
